export const getInitialValues = ({
  period_type: periodType,
  start_date: startDate,
  end_date: endDate,
  max_booking_time: maxBookingTime
}) => ({
  periodType: periodType === 'moving' || periodType === 'available_moving' ? 'rollingDays' : periodType,
  movingType: periodType === 'available_moving' ? 'business' : 'calendar',
  startDate,
  endDate,
  maxBookingTime: maxBookingTime ? Math.floor(maxBookingTime / 24 / 60) : '',
})
